import { Box, DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import { PageHeaderWrapper, Text, Title } from "@src/appV2/redesign/system/ui-components";

export interface BadgeVerificationConfirmContentRedesignProps {
  photoPreviewUrl: string;
  isSubmitting: boolean;
  onBack: () => void;
  onSubmit: () => void;
  onRetakePhoto: () => void;
}

export function BadgeVerificationConfirmContentRedesign(
  props: BadgeVerificationConfirmContentRedesignProps
) {
  const { photoPreviewUrl, isSubmitting, onBack, onSubmit, onRetakePhoto } = props;

  return (
    <>
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow
          hideBackButton={isSubmitting}
          // To still keep the height of the header when back button is hidden
          sx={{ minHeight: 72 }}
          onClickBack={onBack}
        />
      </PageHeaderWrapper>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "auto",
        }}
      >
        <Stack alignItems="center" textAlign="center" spacing={9}>
          <Stack spacing={3} alignItems="center">
            <Title variant="h4" component="h1">
              Confirm badge submission
            </Title>

            <Text variant="body1" color={(theme) => theme.palette.text.secondary}>
              Make sure your badge is worn over your attire, and the photo is clear and
              high-quality.
            </Text>
          </Stack>

          <Box
            sx={(theme) => ({
              width: "100%",
              maxWidth: 300,
              aspectRatio: "3/4",
              borderRadius: theme.shape.borderRadius,
              overflow: "hidden",
              backgroundColor: theme.palette.grey[200],
              marginTop: 4,
            })}
          >
            <Box
              component="img"
              src={photoPreviewUrl}
              alt="Badge photo preview"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <LoadingButton
          fullWidth
          variant="contained"
          size="large"
          isLoading={isSubmitting}
          data-testid="badge-verification-submit-button"
          onClick={onSubmit}
        >
          Submit photo and clock in
        </LoadingButton>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          disabled={isSubmitting}
          onClick={onRetakePhoto}
        >
          Upload a new one
        </Button>
      </DialogFooter>
    </>
  );
}
